export default __webpack_public_path__ + "static/media/ipad-content-2.f7486931.png";